import React from 'react';
import {
  NAMESPACE_ITEMS,
  NAMESPACE_INGREDIENTS,
} from 'actions/inventory/constants';
import styles from './TransferDetail.css';

import ItemDetails from './ItemDetails';
import TransferStock from './TransferStock';
import IngredientTransferStock from './IngredientTransferStock';
import TransferForm from './TransferForm';
import AddItemsModal from './AddItemsModal';

class TransferDetail extends React.Component {
  render() {
    const {
      searchForm,
      transferDetail,
      onClickDone,
      outlets,
      selectedOutlets,
      showAddItemsModal,
      onClickAddItem,
      addItems,
      onModalClickCancel,
      onFromOutletChange,
      itemOptionIsLoading,
      onModalSelectChange,
      onModalAddItems,
      showConfirmSubmitModal,
      setShowConfirmSubmitModal,
      onConfirmCreateTransfer,
      transferItemForm,
      addTransferItemsForm,
      isItemAlreadyAdded,
      onModalSelectInputChange,
      onSubmitCreateTransferForm,
      confirmCreateButtonStatus,
      onModalSearchReachBottom,
      onModalGetFromInit,
      clickLinkIngredient,
    } = this.props;

    return transferDetail ? (
      <div className={styles.wrapper}>
        <div className={`${styles['field-wrapper']} transfer-field-wrapper`}>
          <ItemDetails
            transferDetail={transferDetail}
            searchForm={searchForm}
          />
          {searchForm && searchForm.namespace === NAMESPACE_ITEMS && (
            <TransferStock transferDetail={transferDetail} />
          )}
          {searchForm && searchForm.namespace === NAMESPACE_INGREDIENTS && (
            <IngredientTransferStock transferDetail={transferDetail} />
          )}
        </div>
        <div className={styles.footer}>
          <span className="pull-right">
            <button
              className={`btn btn-primary ${styles['btn-done']}`}
              onClick={onClickDone}
            >
              Done
            </button>
          </span>
        </div>
      </div>
    ) : (
      <div className={styles.wrapper}>
        <div className={styles['form-wrapper']}>
          <TransferForm
            outlets={outlets}
            selectedOutlets={selectedOutlets}
            onClickAddItem={onClickAddItem}
            onFromOutletChange={onFromOutletChange}
            showConfirmSubmitModal={showConfirmSubmitModal}
            setShowConfirmSubmitModal={setShowConfirmSubmitModal}
            onConfirmCreateTransfer={onConfirmCreateTransfer}
            isItemAlreadyAdded={isItemAlreadyAdded}
            onClickDone={onClickDone}
            onSubmitCreateTransferForm={onSubmitCreateTransferForm}
            searchForm={searchForm}
            confirmCreateButtonStatus={confirmCreateButtonStatus}
          />
          <AddItemsModal
            showAddItemsModal={showAddItemsModal}
            addItems={addItems}
            onModalClickCancel={onModalClickCancel}
            itemOptionIsLoading={itemOptionIsLoading}
            onModalSelectChange={onModalSelectChange}
            onModalAddItems={onModalAddItems}
            transferItemForm={transferItemForm}
            addTransferItemsForm={addTransferItemsForm}
            isItemAlreadyAdded={isItemAlreadyAdded}
            onModalSelectInputChange={onModalSelectInputChange}
            searchForm={searchForm}
            onModalSearchReachBottom={onModalSearchReachBottom}
            onModalGetFromInit={onModalGetFromInit}
            clickLinkIngredient={clickLinkIngredient}
          />
        </div>
      </div>
    );
  }
}

export default TransferDetail;
